import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { Observable } from 'rxjs';
import { News } from './def/news-feed';
import { BaseContentService } from './base-content-service';
import { map } from 'rxjs/internal/operators/map';
import { catchError } from 'rxjs/internal/operators/catchError';
import { of } from 'rxjs/internal/observable/of';

@Injectable()
export class NewsFeedContentService extends BaseContentService<News> {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService
  ) {
    super(http, configService, NewsFeedContentService.staticNews);
  }

  get data$(): Observable<News> {
    if (!this.loaded) {
      return this.fetchNewsFeedData();
    }

    return of(this.data);
  }

  private fetchNewsFeedData(): Observable<News> {
    const url = `${this.serviceBaseUrl}ArtisanEdge News`;
    return this.get<News>(url).pipe(
      map(data => {
        this.data = this.newsFeedMapper(data);
        this.loaded = true;
        return this.data;
      }),
      catchError(this.handleError)
    );
  }

  private newsFeedMapper(data: News): News {
    if (!data) return;

    return data;
  }

  private static staticNews: News = {
    pageName: 'ArtisanEdge News',
    newsFeed: [
      {
        date: null,
        align: 'right',
        heading: '',
        title: '',
        description: '',
        text: '',
        image: {
          Alt: '',
          Border: '',
          Class: '',
          Height: 608,
          HSpace: 0,
          Src: '',
          VSpace: 0,
          Width: 1250,
          MediaId: '',
          Title: '',
          Language: {
            Name: 'en'
          }
        },
        displayItems: []
      }
    ]
  };
}
